import React from 'react'

import './TabInterface.scss'
import Utilities from '../../utils/Utilities'

interface IProps {
  children: JSX.Element[]
  className?: string
  hideTextWhenSmall?: boolean
  defaultTab?: string
  setTabCallback?: (mainTabKey: string) => void
}

interface IState {
  activeTabKey?: string
}

const keyToString = (key: string | number | null): string | undefined => {
  return key ? `${key}` : undefined
}

const isActive = (childKey?: string, activeKey?: string): boolean => {
  return childKey === activeKey
}

class TabInterface extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props)

    this.state = {
      activeTabKey: keyToString(this.props.defaultTab || props.children[0].key)
    }

    this.tabButtons = this.tabButtons.bind(this)
  }

  protected tabClick(tabKey: string | undefined): void {
    this.setState({ activeTabKey: tabKey }, (): void => {
      const event = document.createEvent('Event')
      event.initEvent(`show-${tabKey}`, true, true)
      window.dispatchEvent(event)
      if (tabKey && this.props.setTabCallback) {
        this.props.setTabCallback(tabKey)
      }
    })
  }

  // Build the tab buttons at the top of the interface
  protected tabButtons(): JSX.Element[] {
    const { activeTabKey } = this.state
    const { children, hideTextWhenSmall } = this.props

    return children.map(
      (child): JSX.Element => {
        const { icon, name } = child.props
        const childKey = keyToString(child.key)
        return (
          <button
            key={name}
            className={`btn TabButton ${Utilities.classIf(
              isActive(childKey, activeTabKey),
              'active'
            )}`}
            onClick={(): void => this.tabClick(childKey)}
          >
            {icon && <i className={`fas fa-${icon} mr-2`} />}
            <span className={Utilities.classIf(hideTextWhenSmall, 'hidden-xs')}>
              {name}
            </span>
          </button>
        )
      }
    )
  }

  // The actual tabs
  protected tabs(): JSX.Element[] {
    const { activeTabKey } = this.state
    return this.props.children.map(
      (child): JSX.Element => {
        const childKey = keyToString(child.key)
        const showTab = isActive(childKey, activeTabKey) // ? '' : 'none'
        return (
          <div key={childKey} className="row">
            {showTab ? child : ''}
          </div>
        )
      }
    )
  }

  public render(): JSX.Element {
    return (
      <div className={`TabInterface ${this.props.className}`}>
        <div className="row TabButtons">
          <div className="col">{this.tabButtons()}</div>
        </div>
        {this.tabs()}
      </div>
    )
  }
}

export default TabInterface
